import React, { useEffect, useState } from "react";
import { Container, Typography, List, ListItem, ListItemText, Box, Dialog, DialogContent, IconButton, Drawer } from "@mui/material";
import SEO from "../../common/SEO";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import AOS from "aos";
import { getDocumentationSections, } from "../../../services/documentation";
import Grid from "../../common/CustomGrid";
import { BlocksRenderer } from '@strapi/blocks-react-renderer';
import Preloader from '../../common/Preloader'; 
import MenuIcon from '@mui/icons-material/Menu';
//import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css/scrollbar';
import 'swiper/css/free-mode';
import 'swiper/css';
//import { FreeMode, Scrollbar, Mousewheel } from 'swiper/modules';

const navigation = [
      {
        "id": 1,
        "title": "Introducción",
        "slug": "general-overview",
        "url": "/docs/general-overview"
      },
      {
        "id": 2,
        "title": "API Flights",
        "slug": "api-flights",
        "url": "/docs/api-flights"
      },
      {
        "id": 3,
        "title": "API Hotels",
        "slug": "api-hotels",
        "url": "/docs/api-hotels"
      },
      {
        "id": 4,
        "title": "API Trains",
        "slug": "api-trains",
        "url": "/docs/api-trains"
      },
      {
        "id": 5,
        "title": "API Insurance",
        "slug": "api-insurance",
        "url": "/docs/api-insurance"
      },
      {
        "id": 6,
        "title": "API Tour Circuits",
        "slug": "api-circuits",
        "url": "/docs/integrations/tour-circuits"
      }
    ]
  

export default function Documentation() {
    const { slug } = useParams(); 
    const navigate = useNavigate();
    const location = useLocation();
    
    //const [sections, setSections] = useState([]);
    const [selectedSection, setSelectedSection] = useState(null);
    const [mobileOpen, setMobileOpen] = useState(false);
    

    //console.log('selectedSection', selectedSection)

    useEffect(() => {
      AOS.init({ duration: 800, offset: 100 });

      getDocumentationSections()
          .then((data) => {

            if (!data || !Array.isArray(data)) {
                console.error("Error: Datos de documentación no válidos", data);
                return;
              }

              //console.log("Secciones recibidas desde API:", data); // Verifica los datos en la consola

              // Asegura que "Introducción" (general-overview) siempre esté primero
              const sortedSections = data.sort((a, b) => (a.slug === "general-overview" ? -1 : 1));
              //setSections(sortedSections);

              // Buscar la sección por `slug`
              const sectionToShow = slug 
                  ? sortedSections.find((section) => section.slug === slug)
                  : sortedSections.find((section) => section.slug === "general-overview") || sortedSections[0];

                if (!sectionToShow) {
                    navigate("/404", { replace: true }); // Redirige si no existe la sección
                return;
                }

              setSelectedSection(sectionToShow);

              // Si el usuario accede sin slug, redirigir a "general-overview"
              if (!slug && sectionToShow) {
                  navigate(`/docs/${sectionToShow.slug}`, { replace: true });
              }

              
          })
          .catch((error) => console.error("Error cargando documentación", error));
    }, [slug, navigate]);

    const Image = ({ imageUrl, imageAlt }) => {
        const [open, setOpen] = useState(false);
        const handleOpen = () => setOpen(true);
        const handleClose = () => setOpen(false);

        const baseUrl = process.env.REACT_APP_API_URL || "http://localhost:1337";
        const image_url = imageUrl  ? `${baseUrl}${imageUrl}`   : ""; 

        return (
            <>
                <Box
                    component="img"
                    src={image_url}
                    alt={imageAlt}
                    className='hero-image'
                    sx={{ cursor: "pointer", maxWidth: "100%", height: "auto", borderRadius: '8px', border: '1px solid #ddd', padding:'12px' }}
                    onClick={handleOpen}
                />

                <Dialog open={open} onClose={handleClose} maxWidth="lg">
                    <DialogContent>
                        <Box
                            component="img"
                            src={image_url}
                            alt={imageAlt}
                            sx={{ maxWidth: "100%", height: "auto", borderRadius: '8px', border: '1px solid #ddd' }}
                        />
                    </DialogContent>
                </Dialog>
            </>
            );
    };

    if (!selectedSection) {
        //console.error("Error: Datos no disponibles para documentación.");
        return (
            <Preloader />
        );
    };

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

   /*  const SidebarContent2 = (
            <Swiper
                direction="vertical"
                slidesPerView="auto" 
                freeMode={true} 
                mousewheel={true} 
                scrollbar={{ draggable: true }} 
                modules={[FreeMode, Scrollbar, Mousewheel]}
                style={{ height: '75vh' }} 
                className="swiper-scroll"
            >
                <SwiperSlide>
                    <List sx={{width: '100%',}}>
                        {sections.map((section) => {
                            const isActive = location.pathname === `/docs/${section.slug}`;
                            return (
                                
                                    <ListItem
                                        key={section.id}
                                        onClick={() => {
                                            navigate(`/docs/${section.slug}`);
                                            setMobileOpen(false);
                                        }}
                                        selected={isActive}
                                        className={isActive ? "current" : ""}
                                        sx={{
                                            cursor: "pointer",
                                            backgroundColor: isActive ? "#dae4ff" : "transparent",
                                            color: isActive ? "#1449E4" : "inherit",
                                            fontWeight: isActive ? "bold" : "normal",
                                            padding: "4px 12px",
                                            borderRadius: "8px",
                                            width: '100%',
                                            marginBottom: '4px',
                                            
                                            "&:hover": {
                                                backgroundColor: isActive ? "#dae4ff" : "#f0f0f0", 
                                            }
                                        }}
                                    >
                                        <ListItemText primary={section.title} sx={{fontSize: '1.2rem',}} />
                                    </ListItem>
                            
                            );
                        })}
                    </List>
                 </SwiperSlide>
            </Swiper>
    ); */

    const SidebarContent = (
        <List sx={{width: '100%',}}>
            {navigation.map((section) => {
                const isActive = location.pathname === `/docs/${section.slug}`;
                return (
                    <ListItem
                        key={section.id}
                        onClick={() => {
                            navigate(`/docs/${section.slug}`);
                            setMobileOpen(false);
                        }}
                        selected={isActive}
                        className={isActive ? "current" : ""}
                        sx={{
                            cursor: "pointer",
                            backgroundColor: isActive ? "#dae4ff" : "transparent",
                            color: isActive ? "#1449E4" : "inherit",
                            fontWeight: isActive ? "bold" : "normal",
                            padding: "4px 12px",
                            borderRadius: "8px",
                            width: '100%',
                            marginBottom: '4px',
                            
                            "&:hover": {
                                backgroundColor: isActive ? "#dae4ff" : "#f0f0f0", 
                            }
                        }}
                    >
                        <ListItemText primary={section.title} sx={{fontSize: '1.2rem',}} />
                    </ListItem>
                );
            })}
        </List>
);

    

    return (
        <Box className="documentation-page">
            <SEO 
                title="Docs | Documentación y soporte — E2E Travel Solutions"
                description="Accedé a documentación, recursos técnicos y guías de implementación para integraciones y productos E2E."
            />
            <Grid container spacing={2}>
                <IconButton 
                    color="inherit" 
                    aria-label="open drawer"
                    edge="start"
                    onClick={handleDrawerToggle}
                    sx={{ display: { md: "none" }, position: "fixed", top: 16, left: 16, zIndex: 1201 }}
                >
                    <MenuIcon />
                </IconButton>
                <Grid size={{ xs: 12, md: 3 }} sx={{ display: { xs: "none", md: "block" } }}>

                    <Box className="sidebar" sx={{ 
                        position: "sticky", 
                        top: 64, 
                        height: "calc(100vh - 64px)", 
                        borderRight: "1px solid #ddd" ,
                        padding: "16px", 
                        }}>
                        {SidebarContent}  
                    </Box>
                   
                </Grid>
                <Grid size={{ xs: 12, md: 9 }}>
                    <Container className="container-inner">
                        <Grid container spacing={2}>
                            <Grid size={{ xs: 12, md: 8 }}>
                                {selectedSection && <>
                                    <Typography variant="h1" gutterBottom>{selectedSection.title}</Typography>
                                    {selectedSection.content && (
                                        <BlocksRenderer content={selectedSection.content} />
                                    )}
                                </> }
                            </Grid>
                            <Grid size={{ xs: 12, md: 4 }}>
                                <Box sx={{  position: "sticky",  top: 100,  }}>
                                    {selectedSection && selectedSection.image && (
                                    <Image imageUrl={selectedSection.image.url} imageAlt={selectedSection.title} />
                                )}    
                                </Box>                
                            </Grid>
                        </Grid>
                    </Container>
                </Grid>
            </Grid>
            <Drawer
                variant="temporary"
                open={mobileOpen}
                onClose={handleDrawerToggle}
                sx={{
                    display: { xs: "block", md: "none" },
                    "& .MuiDrawer-paper": { width: 250 },
                }}
            >
                {SidebarContent}
            </Drawer>
        </Box>
    );
}
